import { useNavigate } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Header({ symbol }) {
  const socket = useContext(SocketContext);
  const [Ltp, setLtp] = useState(0);
  const [change, setChange] = useState(0);
  const [percent, setPercent] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!socket || !symbol.symbol_id) return;

    socket.emit("giverate", symbol.symbol_id);

    const tradeListener = (data) => {
      if (data && typeof data.LTP !== "undefined") {
        setLtp(data.LTP);

        const ch = data.LTP - data.Previous_Close;
        const pct = (ch / data.Previous_Close) * 100;
        setChange(ch);
        setPercent(pct);
      }
    };

    socket.on(`trade${symbol.symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol.symbol_id}`, tradeListener);
    };
  }, [socket, symbol]);

  const formattedChange = change.toFixed(symbol.digit);
  const formattedPercent = percent.toFixed(2);

  return (
    <div className="px-4 py-3 border-b border-[var(--hover)]">
      <div className="flex items-center ">
        <div className="pr-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-full border-2 border-[var(--hover)] backdrop-[var(--background)] bg-[var(--background)] flex items-center justify-center
             shadow-[0_2px_10px_rgba(0,0,0,0.15)]
             transition-transform duration-300 ease-in-out
             hover:scale-105 active:scale-110"
          >
            <FiChevronLeft className="text-[var(--text)] text-lg" />
          </button>
        </div>
        <div>
          <div className="text-sm font-bold text-[var(--text)]">
            {symbol.symbol_display || symbol.symbol}
          </div>
          <div className="text-xs font-semibold text-[var(--subtext)] uppercase tracking-wide">
            {symbol.type === "nse_cash"
              ? "EQUITY"
              : moment(symbol.expiry_date).format("DD-MMM")}
          </div>
        </div>
        <div className="text-right flex-1">
          <div className="text-lg font-semibold text-[var(--buymeta)]">{Ltp}</div>
          <div className="text-xs text-[var(--buymeta)]">  {formattedChange} ({formattedPercent}%)</div>
        </div>
      </div>
    </div>
  );
}
